module.exports = __webpack_public_path__ + "static/img/banner-2.4967749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-2.jpg
// module id = BHyk
// module chunks = 36